import React, { useState, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { IoIosPin } from "react-icons/io";
import { useLocation, useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { getCity, getCall } from "../../Redux/Actions";
import { Modal } from "react-responsive-modal";
import "./Lp7form.css";

function Lp7form({ buttonId, formId, param, number }) {
  const location = useLocation();
  var url = `https://redcliffelabs.com${location.pathname}/top${location.search}`;

  const [openSuccModel, setSucc] = useState(false);

  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  const [disable, setDisable] = useState(true);

  const history = useHistory();

  //calling city name api
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCity());
  }, []);
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const [phoneError, setPhoneEror] = useState("");
  const [nameError, setNameEror] = useState("");
  const [cityError, setCityError] = useState("");

  //

  const [username, setUserName] = useState("");
  const [phoneNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid username*");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!phoneNumber.match(phoneno) || parseInt(phoneNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };
  //handel form submit
  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        optin: false,
        name: username,
        phone_no: phoneNumber,
        source: "Ecommerce",

        city: userCity,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setUserCity("");

      openSucess(true);

      dispatch(getCall(body));
      // history.push({
      //   search: "?/ThankYou",
      // });
    }
  };

  useEffect(() => {
    if (username == "" || userCity == "" || phoneNumber == "") {
      setDisable(true);
    } else {
      setDisable(false);
    }

    console.log(disable, "disbale value");
  }, [username, userCity, phoneNumber]);
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  return (
    <form
      id={formId ? formId : "normalForm"}
      className="lpform7"
      onSubmit={handelSubmit}
    >
      <div className="lpInput">
        <div className="inputTop">
          <span className="d_flex">
            <FaUserCircle />
          </span>
          <input
            value={username}
            onChange={handelUserName}
            placeholder="Enter Name"
          />
        </div>
        <span className="error">{nameError}</span>
      </div>
      <div className="lpInput">
        <div className="inputTop">
          <span className="d_flex" style={{ fontSize: "14px" }}>
            +91
          </span>
          <input
            value={phoneNumber}
            onChange={handelPhoneChange}
            placeholder="Enter Phone Number"
          />
        </div>
        <span className="error">{phoneError}</span>
      </div>

      <div className="lpInput">
        <div className="inputTop">
          <span className="d_flex">
            <IoIosPin />
          </span>
          <input
            value={userCity}
            onChange={handelCityChange}
            placeholder="Enter City"
          />
        </div>
        <span className="error">{cityError}</span>
        <div
          className={
            userCity !== "" && displayCityList ? "cityList" : "displayNone"
          }
          id="cityList"
        >
          {userCity !== "" && citiesFromArray && citiesFromArray.cities
            ? citiesFromArray.cities
                .filter((name) => {
                  if (userCity == "") {
                    return name;
                  } else if (
                    name.toLowerCase().includes(userCity.toLowerCase())
                  ) {
                    return name;
                  }
                })
                .map((values, index) => {
                  if (index < 2) {
                    return (
                      <>
                        <div
                          onClick={() => setInputcity(values)}
                          key={index}
                          className={
                            displayCityList ? "cityLIstLP" : "displayNone"
                          }
                        >
                          <span>{values}</span>
                        </div>
                      </>
                    );
                  }
                })
            : null}
        </div>
      </div>

      <button
        id={buttonId ? buttonId : "normalButton"}
        type="submit"
        style={{ width: "100%" }}
        disabled={disable ? "disabled" : ""}
        className={disable ? "disabled submitButton" : "submitButton"}
      >
        Book Test Now
      </button>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number="898 898 8585" />
      </Modal>
    </form>
  );
}

export default Lp7form;
